export const labels = {
	/** Default text on 'Call to Action' button in header of mobile creator. */
	addToCart: {
		label: "Label.MobileCreator.Header.AddToCart",
		default: "Add to cart",
	},
	/** Text on 'Call to Action' button in header of mobile creator when Manadory preview is active. */
	next: {
		label: "Label.MobileCreator.Header.Next",
		default: "Next",
	},
	/** Text on 'Call to Action' button in header of mobile creator to update the existing cart item. */
	updateCart: {
		label: "Label.MobileCreator.Header.UpdateCart",
		default: "Update",
	},
	previewBack: {
		label: "Label.MobileCreator.Header.Preview.Back",
		default: "Edit product",
	},
};
